import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'antd';

import './AlertModal.style.less';

export default class AlertModal extends PureComponent {
  renderFooter() {
    const {
      type,
      primaryBtnText,
      primaryBtnClick,
      cancelBtnText,
      cancelBtnClick,
    } = this.props;

    return (
      <div className="alert-modal-footer">
        {type === 'confirm' && (
          <Button
            type="default"
            className="alert-cancel-btn"
            onClick={cancelBtnClick}
          >
            {cancelBtnText}
          </Button>
        )}
        <Button
          type="primary"
          className="alert-primary-btn"
          onClick={primaryBtnClick}
        >
          {primaryBtnText}
        </Button>
      </div>
    );
  }

  render() {
    const { visible, title, description } = this.props;
    const footer = this.renderFooter();

    return (
      <Modal
        className="alert-modal"
        title=""
        centered
        visible={visible}
        width={360}
        closable={false}
        maskClosable={false}
        footer={null}
        bodyStyle={{ padding: 0 }}
      >
        <div className="alert-modal-title">
          <div>{title}</div>
        </div>
        <div className="alert-modal-body">
          <div>{description}</div>
        </div>
        {footer}
      </Modal>
    );
  }
}

AlertModal.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.oneOf(['alert', 'confirm']),
  primaryBtnText: PropTypes.string,
  primaryBtnClick: PropTypes.func,
  cancelBtnText: PropTypes.string,
  cancelBtnClick: PropTypes.func,
  visible: PropTypes.bool,
};
